"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/AssignCertBadgeModal/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Extension_template = require("../../../components/Extension/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Extension_tag = marko_loadTag(Extension_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "position-fixed zindex-5 w-100 h-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 w-100 d-flex justify-content-center",
      renderBody: function(out) {
        out.e("div", marko_attrs1, "2", component, 0, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        WSAdapt_tag({
            ns: "col-9",
            qs: "col-9",
            hs: "col-10",
            renderBody: function(out) {
              Extension_tag({
                  name: "XCredible",
                  payload: {
                    mode: 'fill',
                    ...(input.dataset),
                    callback: input.callback 
                  }
                }, out, __component, "4", [
                [
                  "quit",
                  () => component.emit('dismiss'),
                  false
                ]
              ]);
            }
          }, out, __component, "3");
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
